import React from "react";
import { Play } from "lucide-react";
import { mediaThumbUrl } from "@/lib/mediaUrls";

/**
 * Continuous horizontal auto-scrolling band of media thumbnails.
 * Uses direct <img src=...> with lazy loading so browser handles caching.
 */
const Tile = ({ item }) => {
  return (
    <div className="shrink-0 w-56 md:w-64 h-72 md:h-80 rounded-2xl overflow-hidden polaroid relative">
      {item.media_type === "video" ? (
        <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-rose-950/60 to-[#0F0407]">
          <Play className="w-14 h-14 text-rose-200/90" fill="currentColor" />
        </div>
      ) : (
        <img
          src={mediaThumbUrl(item.id, 480)}
          alt={item.caption || item.original_filename}
          loading="lazy"
          decoding="async"
          className="w-full h-full object-cover"
        />
      )}
      {item.caption && (
        <div className="absolute inset-x-0 bottom-0 p-3 bg-gradient-to-t from-black/80 to-transparent">
          <p className="font-accent text-lg text-rose-100 line-clamp-2">{item.caption}</p>
        </div>
      )}
    </div>
  );
};

export default function GalleryMarquee({ items, direction = "left", speed = 60 }) {
  if (!items || items.length === 0) return null;
  const duplicated = [...items, ...items];
  const duration = `${Math.max(20, items.length * speed)}s`;

  return (
    <div
      data-testid="gallery-marquee"
      className="relative overflow-hidden py-6"
      style={{ maskImage: "linear-gradient(90deg, transparent, #000 6%, #000 94%, transparent)" }}
    >
      <div
        className={`flex gap-5 ${direction === "right" ? "marquee-right" : "marquee-left"}`}
        style={{ animationDuration: duration }}
      >
        {duplicated.map((it, idx) => (
          <Tile key={`${it.id}-${idx}`} item={it} />
        ))}
      </div>
    </div>
  );
}
